import React from 'react';

import type { BannerProps } from '@sravni/react-advertisement/lib/';
import { Banner } from '@sravni/react-advertisement/lib/Banner';
import { BANNER_TYPES } from '@sravni/react-advertisement/lib/constants';
import { useStyles } from '@sravni/react-utils';

import { DEFAULT_BORDERED_BANNERS } from '../../constants/advertisment';

import styles from './bordered-banner.module.scss';

export type BorderedBannerProps = BannerProps;

export const BorderedBanner: React.FC<BorderedBannerProps> = (props) => {
  const { type, className, ...restProps } = props;
  const cx = useStyles(styles);

  const isAddBorderRadius = DEFAULT_BORDERED_BANNERS.includes(type);

  return (
    <Banner
      type={type}
      className={cx(className, {
        withBorderRadius: isAddBorderRadius,
        'withBorderRadius--tgbm7': isAddBorderRadius && type === BANNER_TYPES.TGBM_7,
      })}
      {...restProps}
    />
  );
};
